import React from 'react';
import { Button as MuiButton, CircularProgress } from '@mui/material';
import type { Button as Interface } from '../../design/components';

export const Button: React.FC<Interface> = ({
  name, description, hidden, disabled, loading, onClick
}) => {
  return (
    <MuiButton
      variant="contained"
      disabled={disabled || loading}
      onClick={onClick}
      title={description}
      sx={{ display: hidden ? 'none' : undefined }}
    >
      {loading && <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />}
      {name}
    </MuiButton>
  );
};
